import { render, staticRenderFns } from "./CategoryLayout.vue?vue&type=template&id=73982a0c&scoped=true"
import script from "./CategoryLayout.vue?vue&type=script&lang=js"
export * from "./CategoryLayout.vue?vue&type=script&lang=js"
import style0 from "./CategoryLayout.vue?vue&type=style&index=0&id=73982a0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73982a0c",
  null
  
)

export default component.exports